import React from "react";

import Navbar3 from "../Components/Navbar3";
import Footer from "../Components/Footer";

function TermsConditions() {
  return (
    <>
      <Navbar3 />

      <main className="terms-page">
        <div className="container">
          <div className="terms-content">

            <h1 className="futuraPTMedium">
              Terms and Conditions
            </h1>

            <p className="terms-effective-date">
              <strong>Effective Date:</strong> August 20, 2026
            </p>

            <p>
              These Terms and Conditions ("Terms") govern the use of
              services provided by{" "}
              <strong>ADS Sports Complex, LLC</strong>, doing business
              as <strong>ADS Sports Complex</strong> ("ADS Sports
              Complex," "we," "us," or "our"), including our SMS text
              messaging program.
            </p>

            <p>
              By using our services or opting in to receive text
              messages where applicable, you agree to these Terms.
            </p>

            <h2 className="futuraPTMedium">
              1. SMS Program Description
            </h2>

            <p>
              ADS Sports Complex may use SMS text messaging to provide
              transactional, informational, security-related, and
              operational communications.
            </p>

            <p>
              Messages may include the following.
            </p>

            <h3>
              Authentication and Security Messages
            </h3>

            <p>
              We may send one-time passcodes ("OTPs"), verification
              codes, or multi-factor authentication ("MFA") messages
              when you attempt to access, verify, or secure your
              account.
            </p>

            <p>
              Example:
            </p>

            <div className="terms-sms-example">
              ADS Sports Complex: Your verification code is{" "}
              {"{{verification_code}}"}. This code expires in{" "}
              {"{{expiration_minutes}}"} minutes. Do not share this
              code with anyone.
            </div>

            <h3>
              Order Notifications
            </h3>

            <p>
              Customers who choose to receive order notifications may
              receive messages related to the status of an order,
              including:
            </p>

            <ul>
              <li>Order confirmation</li>
              <li>Order preparation</li>
              <li>Order status changes</li>
              <li>Order readiness</li>
              <li>Pickup notifications</li>
              <li>Delivery notifications</li>
              <li>Delivery delays</li>
              <li>Order cancellations</li>
              <li>
                Other material changes related to an order
              </li>
            </ul>

            <p>
              Example:
            </p>

            <div className="terms-sms-example">
              ADS Sports Complex: Your order{" "}
              {"{{order_number}}"} is now{" "}
              {"{{order_status}}"}.{" "}
              {"{{order_update_details}}"} Reply STOP to opt out or
              HELP for assistance.
            </div>

            <h3>
              Reservation and Event Notifications
            </h3>

            <p>
              Customers who choose to receive reservation or event
              notifications may receive messages regarding:
            </p>

            <ul>
              <li>Reservation confirmations</li>
              <li>Reservation changes</li>
              <li>Schedule changes</li>
              <li>Event updates</li>
              <li>
                Facility, field, court, or room changes
              </li>
              <li>Reservation cancellations</li>
              <li>Event cancellations</li>
              <li>
                Other material updates relating to a reservation or
                scheduled event
              </li>
            </ul>

            <p>
              Example:
            </p>

            <div className="terms-sms-example">
              ADS Sports Complex: Your reservation for{" "}
              {"{{reservation_name}}"} on{" "}
              {"{{reservation_date}}"} at{" "}
              {"{{reservation_time}}"} has been{" "}
              {"{{reservation_status}}"}.{" "}
              {"{{additional_details}}"} Reply STOP to opt out or HELP
              for assistance.
            </div>

            <h3>
              Employee Operational Notifications
            </h3>

            <p>
              Authorized employees may receive operational SMS
              messages related to orders, reservations, events,
              fulfillment, or other work-related activities.
            </p>

            <p>
              These messages may contain information such as:
            </p>

            <ul>
              <li>Order number</li>
              <li>Items ordered</li>
              <li>Order status</li>
              <li>Preparation instructions</li>
              <li>Pickup or delivery information</li>
              <li>Reservation details</li>
              <li>Event information</li>
              <li>Customer fulfillment information</li>
              <li>Operational instructions</li>
            </ul>

            <p>
              Employee messaging is intended for authorized business
              use and may also be subject to applicable ADS Sports
              Complex employment and information-security policies.
            </p>

            <h2 className="futuraPTMedium">
              2. Consent to Receive SMS Messages
            </h2>

            <p>
              Where consent is required, optional order, reservation,
              event, or similar customer notifications will be sent
              only after you affirmatively choose to receive them.
            </p>

            <p>
              Consent to receive optional SMS notifications is not a
              condition of purchasing goods or services from ADS
              Sports Complex.
            </p>

            <p>
              By opting in, you authorize ADS Sports Complex and
              service providers acting on our behalf to send SMS
              messages to the mobile telephone number you provide.
            </p>

            <p>
              You represent that you are the subscriber, account
              holder, or customary user of the telephone number
              provided and that you are authorized to consent to
              receiving messages at that number.
            </p>

            <h2 className="futuraPTMedium">
              3. Transactional and Security Messages
            </h2>

            <p>
              Some SMS messages are initiated in response to an action
              you take, such as requesting a login verification code
              or completing a multi-factor authentication process.
            </p>

            <p>
              These messages are intended to help authenticate your
              identity, protect your account, or complete a
              transaction you requested.
            </p>

            <p>
              Receiving an authentication message does not constitute
              consent to receive unrelated marketing or promotional
              messages.
            </p>

            <h2 className="futuraPTMedium">
              4. Message Frequency
            </h2>

            <p>
              Message frequency varies based on your activity and the
              services you use.
            </p>

            <p>
              The number of messages you receive may depend on factors
              such as:
            </p>

            <ul>
              <li>Authentication attempts</li>
              <li>Orders you place</li>
              <li>Changes to an order</li>
              <li>Reservations you create</li>
              <li>Changes to reservations or events</li>
              <li>
                Operational activity applicable to employees
              </li>
            </ul>

            <p>
              ADS Sports Complex does not guarantee any specific
              message frequency.
            </p>

            <h2 className="futuraPTMedium">
              5. Message and Data Rates
            </h2>

            <p>
              Message and data rates may apply according to the terms
              of your mobile telephone service plan.
            </p>

            <p>
              ADS Sports Complex does not charge a separate fee for
              receiving SMS notifications, but your wireless carrier
              may impose messaging, data, or other charges.
            </p>

            <p>
              Please contact your wireless carrier for information
              about your messaging and data plan.
            </p>

            <h2 className="futuraPTMedium">
              6. Opting Out
            </h2>

            <p>
              You may opt out of applicable SMS notifications at any
              time by replying:
            </p>

            <div className="terms-sms-command">
              STOP
            </div>

            <p>
              to a text message received from ADS Sports Complex.
            </p>

            <p>
              After you send STOP, you may receive a final
              confirmation message informing you that your opt-out
              request has been processed.
            </p>

            <p>
              Once your opt-out request has been processed, you will
              no longer receive the applicable SMS notifications
              unless you subsequently opt in again.
            </p>

            <p>
              ADS Sports Complex does not currently provide a website
              or account-based interface for managing SMS preferences.
              To opt out of SMS notifications, reply{" "}
              <strong>STOP</strong> to a message from ADS Sports
              Complex.
            </p>

            <p>
              Opting out of SMS notifications does not necessarily
              affect communications sent through other channels, such
              as email, when those communications are otherwise
              permitted.
            </p>

            <p>
              If SMS is being used for account authentication or
              security, opting out or otherwise making SMS unavailable
              may require you to use an alternative verification
              method, if one is available.
            </p>

            <h2 className="futuraPTMedium">
              7. Help
            </h2>

            <p>
              For assistance with the ADS Sports Complex SMS messaging
              program, reply:
            </p>

            <div className="terms-sms-command">
              HELP
            </div>

            <p>
              to a text message received from ADS Sports Complex.
            </p>

            <p>
              You may also contact ADS Sports Complex using the
              contact information provided in Section 16 below.
            </p>

            <h2 className="futuraPTMedium">
              8. Changing or Reassigning Your Mobile Number
            </h2>

            <p>
              If you change, deactivate, transfer, or discontinue the
              mobile telephone number you provided to ADS Sports
              Complex, you are responsible for updating your account
              or otherwise notifying us where appropriate.
            </p>

            <p>
              This helps prevent messages intended for you from being
              delivered to another person who may later be assigned
              your former telephone number.
            </p>

            <h2 className="futuraPTMedium">
              9. Message Delivery
            </h2>

            <p>
              SMS message delivery is subject to the availability and
              operation of wireless networks, telecommunications
              providers, and mobile devices.
            </p>

            <p>
              ADS Sports Complex cannot guarantee that every message
              will be delivered.
            </p>

            <p>
              Messages may be delayed or prevented by circumstances
              outside our control, including:
            </p>

            <ul>
              <li>Wireless carrier limitations</li>
              <li>Network outages</li>
              <li>Network congestion</li>
              <li>Device configuration</li>
              <li>Incorrect telephone numbers</li>
              <li>Number blocking</li>
              <li>Spam filtering</li>
              <li>Service interruptions</li>
            </ul>

            <p>
              Wireless carriers are not responsible for delayed or
              undelivered messages.
            </p>

            <h2 className="futuraPTMedium">
              10. No Unrelated Marketing Without Appropriate Consent
            </h2>

            <p>
              The SMS program described in these Terms is primarily
              intended for authentication, transactional,
              informational, and operational communications.
            </p>

            <p>
              ADS Sports Complex will not treat your consent to
              receive order, reservation, event, authentication, or
              other transactional notifications as consent to receive
              unrelated promotional or marketing messages.
            </p>

            <p>
              If ADS Sports Complex introduces marketing or
              promotional SMS messages in the future, we may obtain
              separate consent where required.
            </p>

            <h2 className="futuraPTMedium">
              11. Employee Messaging
            </h2>

            <p>
              Authorized employees may receive SMS messages for
              legitimate business and operational purposes.
            </p>

            <p>
              Employee messages may include information required to
              prepare, fulfill, deliver, coordinate, or manage
              customer orders and reservations.
            </p>

            <p>
              Employees receiving these messages are expected to
              protect customer and company information and use it only
              for authorized business purposes.
            </p>

            <h2 className="futuraPTMedium">
              12. Privacy
            </h2>

            <p>
              Your privacy is important to us.
            </p>

            <p>
              Information collected or processed through our SMS
              messaging program is handled in accordance with the ADS
              Sports Complex Privacy Policy:
            </p>

            <p>
              <a href="/privacypolicy">
                https://adssportscomplex.com/privacypolicy
              </a>
            </p>

            <p>
              SMS opt-in information and consent records will not be
              sold or shared with third parties for their own
              marketing or promotional purposes.
            </p>

            <p>
              We may share information with service providers that
              assist us in delivering and administering SMS services,
              including telecommunications providers, messaging
              providers, wireless carriers, authentication providers,
              cloud service providers, and security providers, only
              as reasonably necessary to provide or support those
              services.
            </p>

            <h2 className="futuraPTMedium">
              13. Prohibited Use
            </h2>

            <p>
              You may not use ADS Sports Complex services or
              communications systems to:
            </p>

            <ul>
              <li>Violate applicable law</li>
              <li>
                Interfere with the operation or security of our
                systems
              </li>
              <li>
                Attempt to gain unauthorized access to accounts or
                systems
              </li>
              <li>
                Misuse authentication or verification codes
              </li>
              <li>Impersonate another person</li>
              <li>
                Engage in fraudulent or deceptive activity
              </li>
            </ul>

            <h2 className="futuraPTMedium">
              14. Changes to These Terms
            </h2>

            <p>
              ADS Sports Complex may update these Terms periodically
              to reflect changes in our services, legal requirements,
              technology, or business practices.
            </p>

            <p>
              When we make changes, we will update the Effective Date
              shown at the top of these Terms.
            </p>

            <p>
              If required by law, we will provide additional notice or
              obtain consent before making material changes that
              affect your rights.
            </p>

            <h2 className="futuraPTMedium">
              15. Disclaimer
            </h2>

            <p>
              SMS communications are provided as a convenience and
              should not be relied upon as the sole source of
              information regarding an order, reservation, event,
              account, or other service.
            </p>

            <p>
              ADS Sports Complex is not responsible for delays or
              failures caused by wireless carriers,
              telecommunications networks, mobile devices,
              third-party service providers, or other circumstances
              outside our reasonable control.
            </p>

            <h2 className="futuraPTMedium">
              16. Contact Us
            </h2>

            <p>
              If you have questions about these Terms or the ADS
              Sports Complex SMS messaging program, contact:
            </p>

            <div className="terms-contact">

              <p>
                <strong>ADS Sports Complex, LLC</strong>
              </p>

              <p>
                doing business as{" "}
                <strong>ADS Sports Complex</strong>
              </p>

              <p className="mt-3">
                Address: 10251 E Loop 1604 N
                <br />
                Converse, TX 78109
              </p>

              <p>
                Email:{" "}
                <a href="mailto:tporter@adssportscomplex.com">
                  tporter@adssportscomplex.com
                </a>
              </p>

              <p>
                Phone:{" "}
                <a href="tel:2108599677">
                  210-859-9677
                </a>
              </p>

              <p>
                Website:{" "}
                <a href="https://adssportscomplex.com">
                  https://adssportscomplex.com
                </a>
              </p>

            </div>

          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default TermsConditions;